var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.allowRemove)?_c('button-custom',{attrs:{"label":_vm.label,"icon":"","color":"error","floatRight":_vm.floatRight},on:{"click":_vm.remove}},[_c('v-icon',[_vm._v("mdi-delete")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }